// =============================================================================
// SimSense Platform — Corner Time-Loss Bar Chart
// =============================================================================


interface CornerLossBarProps {
  comparison: any[]; // Array of { corner: string, timeLossMs: number }
}

export function CornerLossBar({ comparison }: CornerLossBarProps) {
  if (!comparison || comparison.length === 0) return null;

  // Find max absolute loss for scaling
  const maxLoss = Math.max(...comparison.map(c => Math.abs(c.timeLossMs || 0)), 1);

  return (
    <div style={{ background: "var(--card)", padding: "24px", borderRadius: "var(--radius)", border: "1px solid var(--border)", marginBottom: "24px" }}>
      <h3 style={{ fontSize: "16px", marginBottom: "24px" }}>Time Loss per Corner (s)</h3>
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        {comparison.map((c, i) => {
          const isLoss = (c.timeLossMs || 0) > 0;
          const widthPct = (Math.abs(c.timeLossMs || 0) / maxLoss) * 100;
          const lossSec = (c.timeLossMs || 0) / 1000;
          
          return (
            <div key={i} style={{ display: "grid", gridTemplateColumns: "80px 1fr 60px", alignItems: "center", gap: "16px" }}>
              <div style={{ fontSize: "13px", fontWeight: 600, color: "var(--text2)" }}>{c.corner}</div>
              <div style={{ height: "24px", position: "relative", background: "rgba(255,255,255,0.02)", borderRadius: "2px", overflow: "hidden" }}>
                <div 
                  style={{ 
                    position: "absolute",
                    left: "0",
                    top: 0,
                    bottom: 0,
                    width: `${widthPct}%`,
                    background: isLoss ? "#f87171" : "#4ade80",
                    transition: "width 0.3s ease"
                  }}
                />
              </div>
              <div style={{ fontSize: "12px", fontWeight: 700, textAlign: "right", color: isLoss ? "#f87171" : "#4ade80", fontVariantNumeric: "tabular-nums" }}>
                {isLoss ? "+" : ""}{lossSec.toFixed(3)}
              </div>
            </div>
          );
        })}
      </div>
      <div style={{ marginTop: "16px", fontSize: "11px", color: "var(--text2)", textAlign: "center" }}>
        Negative (green) = Faster than reference | Positive (red) = Slower than reference
      </div>
    </div>
  );
}
